import { markPasteRule, PasteRule } from '@tiptap/core';
import { MarkType } from '@tiptap/pm/model';
import { getAbsoluteUrl } from 'shared/getAbsoluteUrl';
import { UrlRegex } from '../../constants';

const MarkdownLinkRegex = /\[([^[\]\n]+)\]\(([^\s()]+)\)/g;

export const markdownLinkPasteRule = (type: MarkType): PasteRule =>
  markPasteRule({
    type,
    find: (text) =>
      Array.from(text.matchAll(MarkdownLinkRegex))
        .filter((match) => UrlRegex.test(match[2]))
        .map((match) => ({
          text: match[0],
          index: match.index ?? 0,
          replaceWith: match[1],
          data: { href: getAbsoluteUrl(match[2]) },
        })),
    getAttributes: (match) => match.data ?? {},
  });
